import {VirtualTeamsConstant as constants} from '../../_constants/VirtualTeams/VirtualTeams.constants';
import {VirtualTeamService as service} from '../../_services/VirtualTeam/VirtualTeam.service';


export const VirtualTeamAction = {
    listApi,
    createApi,
    editApi,
    virtualListApi,
    deleteTeamName,
    memberList,
    addMember,
    updateMember,
    sharedWith,
    shareTeam,
    deleteShared,

    filterTeamApi
}

function filterTeamApi(data, callback) {
    return dispatch => {
        dispatch(request());
        service.filterTeamApi(data)
            .then(
                filteredData => {
                    dispatch(success(filteredData));
                    callback(filteredData, false)
                },
                error => {
                    dispatch(failure(error));
                    callback(error, true)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_FILTER_LOADING } }
    function success(filteredData) { return { type: constants.VIRTUAL_TEAM_FILTER_DATA, filteredData } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_FILTER_ERROR, error } }
    
}

function editApi(data, callback) {
    return dispatch => {
        dispatch(request());
        service.edit_api_service(data)
            .then(
                virtual_edit => {
                    dispatch(success(virtual_edit));
                    callback(virtual_edit, false)
                },
                error => {
                    dispatch(failure(error));
                    callback(error, true)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_EDIT_LOADING } }
    function success(virtual_edit) { return { type: constants.VIRTUAL_TEAM_EDIT_DATA, virtual_edit } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_EDIT_ERROR, error } }
    
}

function deleteShared(data, callback) {
    return dispatch => {
        dispatch(request());
        service.share_del_api(data)
            .then(
                virtual_team_share_delete => {
                    dispatch(success(virtual_team_share_delete));
                    callback(virtual_team_share_delete)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_SHARE_DELETE_LOADING } }
    function success(virtual_team_share_delete) { return { type: constants.VIRTUAL_MEMBER_SHARE_DELETE_DATA, virtual_team_share_delete } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_SHARE_DELETE_ERROR, error } }
    
}

function shareTeam(data, callback) {
    return dispatch => {
        dispatch(request());
        service.share_team_api(data)
            .then(
                virtual_team_share_team => {
                    dispatch(success(virtual_team_share_team));
                    callback(virtual_team_share_team)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_SHARE_TEAM_LOADING } }
    function success(virtual_team_share_team) { return { type: constants.VIRTUAL_MEMBER_SHARE_TEAM_DATA, virtual_team_share_team } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_SHARE_TEAM_ERROR, error } }
    
}

function sharedWith(data, callback) {
    return dispatch => {
        dispatch(request());
        service.shared_with_api(data)
            .then(
                virtual_team_shared_with => {
                    dispatch(success(virtual_team_shared_with));
                    callback(virtual_team_shared_with)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_SHARED_WITH_LOADING } }
    function success(virtual_team_shared_with) { return { type: constants.VIRTUAL_MEMBER_SHARED_WITH_DATA, virtual_team_shared_with } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_SHARED_WITH_ERROR, error } }
    
}

function updateMember(data, callback) {
    return dispatch => {
        dispatch(request());
        service.member_update_api(data)
            .then(
                virtual_update_members => {
                    dispatch(success(virtual_update_members));
                    callback(virtual_update_members)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_UPDATE_LOADING } }
    function success(virtual_update_members) { return { type: constants.VIRTUAL_MEMBER_UPDATE_DATA, virtual_update_members } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_UPDATE_ERROR, error } }
    
}

function addMember(data, callback) {
    return dispatch => {
        dispatch(request());
        service.member_add_api(data)
            .then(
                virtual_add_add_members => {
                    dispatch(success(virtual_add_add_members));
                    callback(virtual_add_add_members)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_ADD_LOADING } }
    function success(virtual_add_add_members) { return { type: constants.VIRTUAL_MEMBER_ADD_DATA, virtual_add_add_members } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_ADD_ERROR, error } }
    
}

function memberList(data, callback) {
    return dispatch => {
        dispatch(request());
        service.member_list_api(data)
            .then(
                virtual_team_members => {
                    dispatch(success(virtual_team_members));
                    callback(virtual_team_members)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_MEMBER_LIST_LOADING } }
    function success(virtual_team_members) { return { type: constants.VIRTUAL_MEMBER_LIST_DATA, virtual_team_members } }
    function failure(error) { return { type: constants.VIRTUAL_MEMBER_LIST_ERROR, error } }
    
}

function deleteTeamName(data, callback) {
    return dispatch => {
        dispatch(request());
        service.delete_team_name(data.data)
            .then(
                virtual_team_change => {
                    dispatch(success(virtual_team_change));
                    callback(virtual_team_change)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_DELETE_LOADING } }
    function success(virtual_team_change) { return { type: constants.VIRTUAL_TEAM_DELETE_DATA, virtual_team_change } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_DELETE_ERROR, error } }
    
}

function virtualListApi(data, callback) {
    return dispatch => {
        dispatch(request());
        service.team_list_service(data)
            .then(
                virtual_team_list => {
                    dispatch(success(virtual_team_list));
                    callback(virtual_team_list)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_LISTMAIN_LOADING } }
    function success(virtual_team_list) { return { type: constants.VIRTUAL_TEAM_LISTMAIN_DATA, virtual_team_list } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_LISTMAIN_ERROR, error } }
    
}

function createApi(data, callback) {
    return dispatch => {
        dispatch(request());
        service.create_api_service(data)
            .then(
                virtual_create => {
                    dispatch(success(virtual_create));
                    callback(virtual_create, false)
                },
                error => {
                    dispatch(failure(error));
                    callback(error, true)                    
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_CREATE_LOADING } }
    function success(virtual_create) { return { type: constants.VIRTUAL_TEAM_CREATE_DATA, virtual_create } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_CREATE_ERROR, error } }
    
}

function listApi(data, callback){
    return dispatch => {
        dispatch(request());
        service.list_api_service(data)
            .then(
                virtual_list_list => {
                    dispatch(success(virtual_list_list));
                    callback(virtual_list_list)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: constants.VIRTUAL_TEAM_LIST_LOADING } }
    function success(virtual_list_list) { return { type: constants.VIRTUAL_TEAM_LIST_DATA, virtual_list_list } }
    function failure(error) { return { type: constants.VIRTUAL_TEAM_LIST_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/VirtualTeams/VirtualTeams.action.js